import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { createApiCallEffects } from '../../../common/store/generic.effects';
import {
  ChequeRemittanceAction,
  chequeRemittanceActions,
} from './cheque-remittance.actions';
import { ChequeRemittanceApiService } from './cheque-remittance.api.service';
import { Store } from '@ngrx/store';
import { searchActions } from '../search/search.actions';

@Injectable()
export class ChequeRemittanceEffects {
  constructor(
    private readonly store: Store<any>,
    private readonly chequeRemittanceApiService: ChequeRemittanceApiService,
    private readonly action$: Actions<ChequeRemittanceAction>,
  ) {}

  getById = createApiCallEffects(
    this,
    this.action$,
    chequeRemittanceActions.getById,
    this.chequeRemittanceApiService.getById,
  );

  createInstance = createApiCallEffects(
    this,
    this.action$,
    chequeRemittanceActions.createInstance,
    this.chequeRemittanceApiService.createInstance,
  );

  add = createApiCallEffects(
    this,
    this.action$,
    chequeRemittanceActions.add,
    this.chequeRemittanceApiService.add,
  );

  delete = createApiCallEffects(
    this,
    this.action$,
    chequeRemittanceActions.delete,
    this.chequeRemittanceApiService.delete,
  );

  deleteFromList = createApiCallEffects(
    this,
    this.action$,
    chequeRemittanceActions.deleteFromList,
    this.chequeRemittanceApiService.delete,
    (value) => {
      this.store.dispatch(searchActions.search.refresh());
    },
  );

  getAccountMovePdf = createApiCallEffects(
    this,
    this.action$,
    chequeRemittanceActions.getChequeRemittancePdf,
    this.chequeRemittanceApiService.getChequeRemittancePdf,
  );
}
